import { tss } from 'tss-react';

export const useResizableStyles = tss.create({
  handleRight: {
    // Make it not hidden behind the drawer
    zIndex: 100
  }
});

export const useSx = props => ({
  width: props.width, // use width from props
  flexShrink: 0,
  '& .MuiToolbar-root': {
    marginBottom: 1
  },
  '& .MuiDivider-root': {
    marginTop: 1
  },
  '& .MuiDrawer-paper': {
    width: props.width // use width from props
  }
});
